import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AcademicYear {
  id: number;
  academicYear: string;
  startDate: string;
  endDate: string;
  isActive: boolean;
}

interface AcademicYearState {
  selectedAcademicYear: AcademicYear | null;
  academicYears: AcademicYear[];
  loading: boolean;
  error: string | null;
}

const initialState: AcademicYearState = {
  selectedAcademicYear: null,
  academicYears: [],
  loading: false,
  error: null,
};

const academicYearSlice = createSlice({
  name: 'academicYear',
  initialState,
  reducers: {
    setAcademicYears(state, action: PayloadAction<AcademicYear[]>) {
      state.academicYears = action.payload;
    },
    setSelectedAcademicYear(state, action: PayloadAction<AcademicYear>) {
      state.selectedAcademicYear = action.payload;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
  },
});

export const {
  setAcademicYears,
  setSelectedAcademicYear,
  setLoading,
  setError,
} = academicYearSlice.actions;

export default academicYearSlice.reducer;